import { TRootState } from 'redusers';
import { IDownloadProcessRes } from 'api/downloadManager.types';

export const selectDownloadProcesses = ({ downloadManager }: TRootState): IDownloadProcessRes[] => (
  downloadManager.processes
);
